import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Title } from '@tremor/react';
import { getSession, getOrDeleteRequest } from '../../utils/utils.js';
import DoughnutChart from './ComponentChart/DoughnutChart';
import BarChart from './ComponentChart/BarChart';
import CompanyImage from '../../images/companies.png';
import CountUpText from '../../components/Animations/CountUpText.jsx';
import { prepareBarChartData } from '../../services/dashboard/formatDataDashboards';
import { parseReportToTable } from '../../services/dashboard/formatDataTableIndicators';
import LineChart from './ComponentChart/LineChart';
import TableBarChart from './ComponentChart/TableBarChart';
import TableIndicators from './ComponentChart/TableIndicators';
import TableCompanies from './ComponentChart/TableCompanies';
import MapComponent from '../../components/Map/MapV3';
import BarList from './ComponentChart/BarList';
import { CustomDropdown } from './ComponentChart/CustomDropdown';
import { formatProjectsToOptions } from '../../services/dashboard/formatDataSelects';
import { extractFirstHistories } from '../../services/dashboard/formatHistoryIndicators';
import ExportDataButton from './ComponentChart/ButtonExportXlxs';
import ExportDataButtonPdf from './ComponentChart/ButtonExportPdf';
import { exportToExcel } from '../../data/dataFormatExcelReport';
import CalendarCard from './ComponentChart/IconCalendar';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import "jspdf-autotable";
import { formatCompaniesToOptions } from '../../services/dashboard/formatSelectCompanies';
import RangeSelects from './ComponentChart/RangeSelects';
import { customSwal } from '../../utils/utils.js';
import { useNavigate } from 'react-router-dom';
import { consolidateFactorsData } from '../../services/dashboard/consolidateFactorsData.js';
import { formatFactorsData } from '../../services/dashboard/formatDataFactors.js';
import BarChartFactors from './ComponentChart/BarChartFactors.jsx';
import MainThemeLayout from '../../layout/MainThemeLayout.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import ModalIndicatorDetails from '../../Modals/ModalIndicatorDetails.jsx';
import { set } from 'date-fns';

// Eliminado el tipado de Date
const normalizeToMonth = (date) =>
    new Date(date.getFullYear(), date.getMonth(), 1);

const Dashboardv2 = () => {
    const session = getSession();
    console.log("Sesión del usuario:", session);

    // Eliminados los genéricos de useRef
    const chartDoughnut1 = useRef(null);
    const chartDoughnut2 = useRef(null);
    const chartDoughnut3 = useRef(null);
    const chartBar1 = useRef(null);
    const chartLine1 = useRef(null);
    const chartFactors = useRef(null);

    const navigate = useNavigate();

    const options = [
        { label: "Departamento A", value: "depA" },
        { label: "Departamento B", value: "depB" },
        { label: "Departamento C", value: "depC" },
    ];

    const initialDataGeneral = {
        project: { project_name: '', start_date: '', end_date: '' },
        total_company_types: [],
        total_company_states: [],
        total_company_cities: [],
        total_indicator_groups: 0,
        total_reports_by_company: [],
        total_companies: 0,
        total_partners: 0,
        total_reports: 0
    };

    let initialFilters = null;

    initialFilters = {
        project_id: '',
        company_id: '',
        company_type_id: '',
        sector_id: '',
        department_id: '',
        city_id: '',
        state_id: '',
        district_id: '',
        date_from: '',
        date_to: '',
    };

    if (session && session.type_id == 4) {
        // console.log("sesion =>", session);
        initialFilters = {
            company_id: session.id || '',
            date_from: '',
            date_to: '',
        };
    }

    // Eliminados todos los genéricos <Type> de los useState
    const [dataGeneral, setDataGeneral] = useState(initialDataGeneral);
    const [dataIndicators, setDataIndicators] = useState(null);
    const [dataIndicatorsFormatChart, setDataIndicatorsFormatChart] = useState(null);
    const [dataIndicatorsFormatTable, setDataIndicatorsFormatTable] = useState(null);
    const [isLoadingIndicators, setIsLoadingIndicators] = useState(false);
    const [isLoadingFactors, setIsLoadingFactors] = useState(false);
    const [isLoadingFilters, setIsLoadingFilters] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [dataProjects, setDataProjects] = useState([]);
    const [historiesIndicators, setHistoriesIndicators] = useState(null);
    const [dataToExcel, setDataToExcel] = useState([]);
    const [selectedDatasets, setSelectedDatasets] = useState([]);
    const [selectedLineDatasets, setSelectedLineDatasets] = useState([]);
    const [selectedIndicators, setSelectedIndicators] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [filters, setFilters] = useState(initialFilters);
    const [optionCompanyTypes, setOptionCompanyTypes] = useState([]);
    const [selectedOptionCompanyTypes, setSelectedOptionCompanyTypes] = useState(null);
    const [optionCompanySector, setOptionCompanySector] = useState([]);
    const [selectedOptionCompanySector, setSelectedOptionCompanySector] = useState(null);
    const [optionStates, setOptionStates] = useState([]);
    const [selectedOptionState, setSelectedOptionState] = useState(null);
    const [optionCities, setOptionCities] = useState([]);
    const [selectedOptionCity, setSelectedOptionCity] = useState(null);
    const [optionDistricts, setOptionDistricts] = useState([]);
    const [selectedOptionDistrict, setSelectedOptionDistrict] = useState(null);
    const [cacheReport, setCacheReport] = useState('');
    const [dataFactors, setDataFactors] = useState(null);
    const [dataFactorsRaw, setDataFactorsRaw] = useState(null);
    const [selectedFactors, setSelectedFactors] = useState([]);
    const [showModalIndicatorDetails, setShowModalIndicatorDetails] = useState(false);
    const [dataIndicatorDetails, setDataIndicatorDetails] = useState([]);

    // Funciones: quitamos tipos de parámetros y retornos
    const getDataGeneral = async (id = "7", params) => {
        try {
            let endpoint = `dashboard/project-statics/${id}`;
            if (params) {
                const query = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== '') {
                        query.append(key, value.toString());
                    }
                });
                const queryString = query.toString();
                if (queryString) endpoint += `?${queryString}`;
            }
            const response = await getOrDeleteRequest(endpoint, 'GET');
            if (response.type !== 'success') throw new Error('Verifica los datos');
            setDataGeneral(response.data);
        } catch (error) {
            console.error('Error: ', error);
        }
    };

    const getDataIndicators = async (id = "7", params) => {
        try {
            setIsLoadingIndicators(true);
            let endpoint = session && session.type_id == 4 ? `report-details/by-project/${id}/company/${session.id}` : `report-details/by-project/${id}`;
            // let endpoint = `report-details/by-project/${id}`;
            if (params) {
                console.log("Parámetros para indicadores:", params);
                const query = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        query.append(key, value.toString());
                    }
                });
                const queryString = query.toString();
                if (queryString) endpoint += `?${queryString}`;
            }
            console.log("Endpoint indicadores:", endpoint);
            const response = await getOrDeleteRequest(endpoint, 'GET');
            if (response.type !== 'success') throw new Error('Error en indicadores');

            setDataIndicators(response.data);
            setDataIndicatorsFormatTable(parseReportToTable(response));
            const dataPrepared = prepareBarChartData(response);
            setDataIndicatorsFormatChart(dataPrepared);
            const histories = extractFirstHistories(response);
            setHistoriesIndicators(histories);
            setCacheReport(response.cache_key);
        } catch (error) {
            console.error('Error indicadores: ', error);
        }
    };

    const getDataProjects = async (id) => {
        try {
            let endpoint = id ? `projects/show/${id}` : 'projects/filter';

            if (session && session.type_id == 4) {
                endpoint = endpoint + `?company_id=${session?.company?.id}`;
            }

            const response = await getOrDeleteRequest(endpoint, 'GET');
            if (response.type !== 'success') throw new Error('Error proyectos');
            const formatProjects = formatProjectsToOptions(response.data);
            setDataProjects(formatProjects);
            setSelectedProject(id ? formatProjects.find(proj => proj.value.toString() === id) || null : formatProjects.find(proj => proj.value.toString() === '7') || null);
            getDataIndicators(id ? id : '7');
        } catch (error) {
            console.error('Error proyectos: ', error);
        }
    };

    const onChangeDropdown = (option, type) => {
        if (type === 'projects') {
            setSelectedProject(option);
            setFilters(prev => ({ ...prev, project_id: option.value.toString() }));
        }
        if (type === 'companies') {
            setSelectedCompany(option);
            setSelectedOptionCompanyTypes(null);
            setSelectedOptionCompanySector(null);
            setFilters(prev => ({ ...prev, company_id: option.value.toString(), company_type_id: '', sector_id: '' }));
        }
        if (type === 'CompanyTypes') {
            setSelectedOptionCompanyTypes(option);
            setFilters(prev => ({ ...prev, company_type_id: option.value.toString() }));
        }
        if (type === 'CompanySector') {
            setSelectedOptionCompanySector(option);
            setFilters(prev => ({ ...prev, sector_id: option.value.toString() }));
        }
        if (type === 'States') {
            setSelectedOptionState(option);
            setFilters(prev => ({ ...prev, state_id: option.value.toString(), city_id: '', district_id: '' }));
            setSelectedOptionCity(null);
            setSelectedOptionDistrict(null);
            getDataCities(option.value.toString());
        }
        if (type === 'Cities') {
            setSelectedOptionCity(option);
            setFilters(prev => ({ ...prev, city_id: option.value.toString(), district_id: '' }));
            setSelectedOptionDistrict(null);
            getDataDistricts(option.value.toString());
        }
        if (type === 'Districts') {
            setSelectedOptionDistrict(option);
            setFilters(prev => ({ ...prev, district_id: option.value.toString() }));
        }
    };

    const resetDropdown = (type) => {
        if (type === 'projects') {
            setSelectedCompany(null);
            getDataIndicators("7");
        }
        if (type === 'companies') {
            setSelectedCompany(null);
            setFilters(prev => ({ ...prev, company_id: '' }));
            getDataIndicators(selectedProject ? selectedProject.value : "7");
        }
        if (type === 'CompanyTypes') {
            setSelectedOptionCompanyTypes(null);
            setFilters(prev => ({ ...prev, company_type_id: '' }));
            getDataIndicators(selectedProject ? selectedProject.value : "7");
        }
        if (type === 'CompanySector') {
            setSelectedOptionCompanySector(null);
            setFilters(prev => ({ ...prev, sector_id: '' }));
            getDataIndicators(selectedProject ? selectedProject.value : "7");
        }
        if (type === 'States') {
            setSelectedOptionState(null);
            setSelectedOptionCity(null);
            setSelectedOptionDistrict(null);
            setFilters(prev => ({ ...prev, state_id: '', city_id: '', district_id: '' }));
        }
        if (type === 'Cities') {
            setSelectedOptionCity(null);
            setSelectedOptionDistrict(null);
            setFilters(prev => ({ ...prev, city_id: '', district_id: '' }));
        }
        if (type === 'Districts') {
            setSelectedOptionDistrict(null);
            setFilters(prev => ({ ...prev, district_id: '' }));
        }
    };

    const getReportExcel = async (id = "7", params, cacheKey) => {
        try {
            let endpoint = `report-details/excel/${id}?cache_key=${cacheKey}`;
            if (params) {
                const query = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) query.append(key, value.toString());
                });
                const queryString = query.toString();
                if (queryString) endpoint += `?${queryString}`;
            }
            const response = await getOrDeleteRequest(endpoint, 'GET');
            if (response.type === 'success') {
                setDataToExcel(response.data);
                const projectName = dataGeneral?.project?.project_name || "Reporte";
                const sanitizedProjectName = projectName.replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s+/g, "_");
                exportToExcel(response.data, `Reporte_${sanitizedProjectName}`);
            }
        } catch (error) {
            customSwal.fire({
                title: 'Reacarga de Datos',
                text: 'Datos actualizados.',
                icon: 'warning',
                timer: 3000
            }).then(() => {
                getDataIndicators(selectedProject ? selectedProject.value : "7", filters);
            });
        }
    };

    const handleExport = () => {
        if (selectedProject) {
            getReportExcel(selectedProject.value, filters, cacheReport);
        }
    };

    const getCompanies = async (id) => {
        const endpoint = id ? `company/filter?project_id=${id}` : 'company/filter';
        const response = await getOrDeleteRequest(endpoint, 'GET');
        console.log("Respuesta compañías:", response);
        if (response.type === 'success') {
            setCompanies(formatCompaniesToOptions(response.data));
        }
    };

    const exportPDFGrid = async () => {
        const pdf = new jsPDF();
        const chartsConfig = [
            { ref: chartDoughnut1, title: "Tipos de empresas" },
            { ref: chartDoughnut2, title: "Empresas por departamento" },
            { ref: chartDoughnut3, title: "Empresas por municipio" },
            { ref: chartBar1, title: "Variables Consolidadas" },
            { ref: chartLine1, title: "Variables por Mes" },
            { ref: chartFactors, title: "Emisiones" }
        ];

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const chartWidth = 140;
        const margin = 20;
        const titleHeight = 10;

        const projectName = dataGeneral?.project?.project_name || "General";
        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        let titleText = `Reporte de Gráficos: ${projectName}`;
        /**Agregar nombre de la empresa si esta filtrado */
        if (selectedCompany) {
            titleText += ` - ${selectedCompany.label}`;
        }
        let titleLines = pdf.splitTextToSize(titleText, pageWidth - 40);

        pdf.text(titleLines, pageWidth / 2, 15, { align: "center" });

        chartsConfig.forEach(chart => chart.ref.current?.toggleLegend?.(false));
        await new Promise(resolve => setTimeout(resolve, 500));

        let yPosition = margin + 15;

        for (let index = 0; index < chartsConfig.length; index++) {
            const chart = chartsConfig[index];
            const canvas = chart.ref.current?.getCanvas();
            if (!canvas) continue;

            const img = canvas.toDataURL("image/png");
            const imgProps = pdf.getImageProperties(img);
            const pdfHeight = (imgProps.height * chartWidth) / imgProps.width;

            if (yPosition + titleHeight + pdfHeight > pageHeight - margin) {
                pdf.addPage();
                yPosition = margin;
            }

            pdf.setFontSize(12);
            pdf.text(chart.title, pageWidth / 2, yPosition + 5, { align: "center" });
            pdf.addImage(img, "PNG", (pageWidth - chartWidth) / 2, yPosition + titleHeight, chartWidth, pdfHeight);

            yPosition += titleHeight + pdfHeight + 5;

            if (chart.ref.current?.getLegendData) {
                const legendData = chart.ref.current.getLegendData();
                if (legendData && legendData.length > 0) {
                    autoTable(pdf, {
                        startY: yPosition,
                        head: [['Color', 'Nombre', 'Valor']],
                        body: legendData.map(item => ['', item.label, item.value]),
                        didParseCell: (data) => {
                            if (data.section === 'body' && data.column.index === 0) {
                                let color = legendData[data.row.index].color;
                                if (color && color.startsWith('rgba')) {
                                    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
                                    if (match) data.cell.styles.fillColor = [parseInt(match[1]), parseInt(match[2]), parseInt(match[3])];
                                } else {
                                    data.cell.styles.fillColor = color;
                                }
                            }
                        },
                        theme: 'grid',
                    });
                    yPosition = pdf.lastAutoTable.finalY + 20;
                }
            }
        }
        const sanitizedProjectName = projectName.replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s+/g, "_");
        pdf.save(`Reporte_Graficos_${sanitizedProjectName}.pdf`);
    };

    const getDataCompanyTypes = async () => {
        try {
            const response = await getOrDeleteRequest('company-type/filter', 'GET');
            if (response.type === 'success') setOptionCompanyTypes(formatProjectsToOptions(response.data));
        } catch (error) { console.warn(error); }
    };

    const getDataSector = async () => {
        try {
            const response = await getOrDeleteRequest('business_sectors/filter', 'GET');
            if (response.type === 'success') setOptionCompanySector(formatProjectsToOptions(response.data));
        } catch (error) { console.warn(error); }
    };

    const getDataStates = async () => {
        try {
            const response = await getOrDeleteRequest('states/filter', 'GET');
            if (response.type === 'success') setOptionStates(formatProjectsToOptions(response.data));
        } catch (error) { console.warn(error); }
    };

    const getDataCities = async (id) => {
        try {
            setIsLoadingFilters(true);
            const response = await getOrDeleteRequest(`cities/by-state/${id}`, 'GET');
            if (response.type === 'success') setOptionCities(formatProjectsToOptions(response.data));
        } finally { setIsLoadingFilters(false); }
    };

    const getDataDistricts = async (id) => {
        try {
            setIsLoadingFilters(true);
            const response = await getOrDeleteRequest(`districts/by-city/${id}`, 'GET');
            if (response.type === 'success') setOptionDistricts(formatProjectsToOptions(response.data));
        } finally { setIsLoadingFilters(false); }
    };

    const handleDateRange = (range) => {
        setFilters(prev => ({
            ...prev,
            date_from: range.from || '',
            date_to: range.to || ''
        }));
    };

    function capitalizeFirstLetter(text) {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    const getFactors = async () => {
        try {
            setIsLoadingFactors(true);
            const response = await getOrDeleteRequest(`report-details/factors?cache_key=${cacheReport}`, 'GET');
            if (response.type !== 'success') throw new Error('Error factores');
            const factorsData = formatFactorsData(response.data);
            setDataFactorsRaw(response.data);
            const consolidatedData = consolidateFactorsData(factorsData);
            const transformedData = {
                labels: consolidatedData.labels,
                datasets: consolidatedData.datasets.map(ds => ({
                    ...ds,
                    backgroundColor: Array.isArray(ds.backgroundColor) ? ds.backgroundColor[0] : ds.backgroundColor,
                    borderColor: Array.isArray(ds.borderColor) ? ds.borderColor[0] : ds.borderColor,
                }))
            };
            setDataFactors(transformedData);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingFactors(false);
        }
    };

    useEffect(() => {
        const initData = async () => {
            setIsLoadingFilters(true);
            await Promise.all([getDataProjects(''), getDataCompanyTypes(), getDataSector(), getDataStates()]);
            setIsLoadingFilters(false);
        }
        initData();
    }, []);

    useEffect(() => {
        if (!selectedProject) return;
        const refreshData = async () => {
            setIsLoadingFilters(true);
            await Promise.all([getDataGeneral(selectedProject.value, filters), getDataIndicators(selectedProject.value, filters)]);
            setIsLoadingFilters(false);
        };
        refreshData();
    }, [filters, selectedProject]);

    useEffect(() => {
        setIsLoadingIndicators(false);
        getFactors();
    }, [dataIndicatorsFormatChart]);

    useEffect(() => {
        selectedProject && getCompanies(selectedProject.value.toString());
    }, [selectedProject]);

    const handleExportFactors = () => {
        if (!dataFactorsRaw) return;
        const rootData = dataFactorsRaw.data || dataFactorsRaw;
        const aggregatedRows = new Map();

        for (const date in rootData) {
            const companies = rootData[date];
            if (!companies || typeof companies !== 'object') continue;
            for (const companyKey in companies) {
                const companyName = companyKey.replace(/^\d+__/, "").replace(/_/g, " ");
                const company = companies[companyKey];
                let companyType = company.company_type || "Desconocido";
                for (const groupKey in company) {
                    if (groupKey === 'company_type') continue;
                    const group = company[groupKey];
                    for (const indicatorKey in group) {
                        const indicator = group[indicatorKey];
                        if (indicator.factor && typeof indicator.factor === 'object') {
                            const factorName = indicator.factor.name;
                            const uniqueKey = `${companyName}|${factorName}`;
                            const currentValue = Number(indicator.factor.value) || 0;
                            if (!aggregatedRows.has(uniqueKey)) {
                                aggregatedRows.set(uniqueKey, {
                                    Empresa: companyName,
                                    "Tipo de Empresa": companyType,
                                    Factor: factorName,
                                    Valor: currentValue,
                                    Unidad: indicator.factor.unit || 'CO2e'
                                });
                            }
                        }
                    }
                }
            }
        }
        const projectName = dataGeneral?.project?.project_name || "General";
        const sanitizedProjectName = projectName.replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s+/g, "_");
        exportToExcel(Array.from(aggregatedRows.values()), `Reporte_Factores_${sanitizedProjectName}`);
    };

    const getIndicatorDetails = async () => {
        try {
            const response = await getOrDeleteRequest(`projects/indicators-details/${selectedProject.value}`, 'GET');
            if (response.type !== 'success') throw new Error('Error detalles del indicador');
            console.log("Detalles del indicador:", response.data);
            setDataIndicatorDetails(response.data);
            setShowModalIndicatorDetails(true);
        } catch (error) {
            setShowModalIndicatorDetails(false);
            console.error("Error - :", error);
        }
    }

    return (
        <MainThemeLayout>
            <section className='px-4'>
                <section className="flex flex-col flex-grow">
                    <div className="">
                        <div className='p-4 bg-white rounded mb-4'>
                            <section className='border-none'>
                                <h1 className='text-center font-bold pb-4'>Filtros de datos</h1>
                                <div className='flex flex-wrap'>
                                    <div className="w-full p-2">
                                        <h2 className="mb-4 font-bold">Filtrar por proyecto</h2>
                                        <CustomDropdown
                                            options={dataProjects}
                                            selected={selectedProject}
                                            onChange={(option) => onChangeDropdown(option, 'projects')}
                                            id="project-dropdown"
                                            disabled={isLoadingFilters}
                                        />
                                        {selectedProject &&
                                            <div className='flex items-center mt-4 gap-2'>
                                                <div onClick={() => resetDropdown('projects')} className='bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center'>x</div>
                                                <p className="">{selectedProject.label}</p>
                                            </div>
                                        }
                                    </div>
                                    {session && [1].includes(session.type_id) &&
                                        <>
                                            <div className="w-1/2 p-2">
                                                <h2 className="mb-4 font-bold">Filtrar por empresa o entidad</h2>
                                                <CustomDropdown
                                                    options={companies}
                                                    selected={selectedCompany}
                                                    onChange={(option) => onChangeDropdown(option, 'companies')}
                                                    id="company-dropdown"
                                                    disabled={isLoadingFilters}
                                                />
                                                {selectedCompany &&
                                                    <div className='flex items-center mt-4 gap-2'>
                                                        <div onClick={() => resetDropdown('companies')} className='bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center'>x</div>
                                                        <p className="">{selectedCompany.label}</p>
                                                    </div>
                                                }
                                            </div>
                                            <div className="w-1/2 p-2">
                                                <h2 className="mb-4 font-bold">Filtrar por tipo de empresa o entidad</h2>
                                                <CustomDropdown
                                                    options={optionCompanyTypes}
                                                    selected={selectedOptionCompanyTypes}
                                                    onChange={(option) => onChangeDropdown(option, 'CompanyTypes')}
                                                    disabled={isLoadingFilters || selectedCompany !== null}
                                                />
                                                {selectedOptionCompanyTypes &&
                                                    <div className='flex items-center mt-4 gap-2'>
                                                        <div onClick={() => resetDropdown('CompanyTypes')} className='bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center'>x</div>
                                                        <p className="">{selectedOptionCompanyTypes.label}</p>
                                                    </div>
                                                }
                                            </div>
                                            <div className="w-1/2 p-2">
                                                <h2 className="mb-4 font-bold">Filtrar por sector</h2>
                                                <CustomDropdown
                                                    options={optionCompanySector}
                                                    selected={selectedOptionCompanySector}
                                                    onChange={(option) => onChangeDropdown(option, 'CompanySector')}
                                                    disabled={isLoadingFilters || selectedCompany !== null}
                                                />
                                                {selectedOptionCompanySector &&
                                                    <div className='flex items-center mt-4 gap-2'>
                                                        <div onClick={() => resetDropdown('CompanySector')} className='bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center'>x</div>
                                                        <p className="">{selectedOptionCompanySector.label}</p>
                                                    </div>
                                                }
                                            </div>
                                            <div className="w-1/2 p-2">
                                                <h2 className="mb-4 font-bold">Filtrar por Departamento</h2>
                                                <CustomDropdown
                                                    options={optionStates}
                                                    selected={selectedOptionState}
                                                    onChange={(option) => onChangeDropdown(option, 'States')}
                                                    disabled={isLoadingFilters || selectedCompany !== null}
                                                />
                                                {selectedOptionState &&
                                                    <div className='flex items-center mt-4 gap-2'>
                                                        <div onClick={() => resetDropdown('States')} className='bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center'>x</div>
                                                        <p className="">{selectedOptionState.label}</p>
                                                    </div>
                                                }
                                            </div>
                                            <div className="w-1/2 p-2">
                                                <h2 className="mb-4 font-bold">Filtrar por Municipio</h2>
                                                <CustomDropdown
                                                    options={optionCities}
                                                    selected={selectedOptionCity}
                                                    onChange={(option) => onChangeDropdown(option, 'Cities')}
                                                    disabled={isLoadingFilters || selectedOptionState === null}
                                                />
                                                {selectedOptionCity &&
                                                    <div className='flex items-center mt-4 gap-2'>
                                                        <div onClick={() => resetDropdown('Cities')} className='bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center'>x</div>
                                                        <p className="">{selectedOptionCity.label}</p>
                                                    </div>
                                                }
                                            </div>
                                            <div className="w-1/2 p-2">
                                                <h2 className="mb-4 font-bold">Filtrar por Distrito</h2>
                                                <CustomDropdown
                                                    options={optionDistricts}
                                                    selected={selectedOptionDistrict}
                                                    onChange={(option) => onChangeDropdown(option, 'Districts')}
                                                    disabled={isLoadingFilters || selectedOptionCity === null}
                                                />
                                                {selectedOptionDistrict &&
                                                    <div className='flex items-center mt-4 gap-2'>
                                                        <div onClick={() => resetDropdown('Districts')} className='bg-zinc-600 rounded-full hover:cursor-pointer w-4 h-4 text-white text-xs flex justify-center items-center'>x</div>
                                                        <p className="">{selectedOptionDistrict.label}</p>
                                                    </div>
                                                }
                                            </div>
                                        </>
                                    }

                                    <div className="w-full p-2">
                                        <RangeSelects onChange={handleDateRange} disabled={isLoadingFilters} />
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className='p-4 bg-white rounded my-4'>
                            <section>
                                <div className='flex'>
                                    <div className='w-1/2'>
                                        <Title className="text-lg text-start pb-3 font-medium dark:text-white">Proyecto: {dataGeneral.project ? dataGeneral.project.project_name : "No se encontro el proyecto"}</Title>
                                        <div className='flex items-center gap-2'>
                                            {dataIndicatorsFormatChart && <ExportDataButton label="Exportar Excel" onClick={handleExport} disabled={isLoadingFilters || isLoadingIndicators} />}
                                            {dataIndicatorsFormatChart && <ExportDataButtonPdf label="Exportar PDF" onClick={exportPDFGrid} disabled={isLoadingFilters || isLoadingIndicators || isLoadingFactors} />}
                                        </div>
                                    </div>
                                    <div className='w-1/2 flex items-center justify-around flex-wrap gap-4'>
                                        <div className=''>
                                            <CalendarCard
                                                label="Desde"
                                                date={dataGeneral.project?.start_date ?? "0000-00-00"}
                                            />
                                        </div>
                                        <div className=''>
                                            <CalendarCard
                                                label="Hasta"
                                                date={dataGeneral.project?.end_date ?? "0000-00-00"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        {session && [1].includes(session.type_id) &&
                            <>
                                <div className='flex flex-wrap'>
                                    <div className='w-full sm:w-1/2 md:w-1/2 lg:w-1/3 p-2'>
                                        <div className='bg-white rounded my-4 p-4'>
                                            <h1 className='text-center font-bold pb-4'>Total de empresas</h1>
                                            <div className='flex items-center justify-around'>
                                                <h2 className='text-center text-2xl font-bold truncate'><CountUpText value={dataGeneral ? dataGeneral.total_companies : 0} duration={100} className='text-2xl font-bold' /></h2>
                                                <img src={CompanyImage} width={'50px'} alt="Empresas" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='w-full sm:w-1/2 md:w-1/2 lg:w-1/3 p-2'>
                                        <div className='bg-white rounded my-4 p-4'>
                                            <h1 className='text-center font-bold pb-4'>Total de aliados</h1>
                                            <div className='flex items-center justify-around'>
                                                <h2 className='text-center text-2xl font-bold truncate'><CountUpText value={dataGeneral ? dataGeneral.total_partners : 0} duration={100} className='text-2xl font-bold' /></h2>
                                                <img src={CompanyImage} width={'50px'} alt="Empresas" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='w-full sm:w-1/2 md:w-1/2 lg:w-1/3 p-2'>
                                        <div className='bg-white rounded my-4 p-4'>
                                            <h1 className='text-center font-bold pb-4'>Total de reportes</h1>
                                            <div className='flex items-center justify-around'>
                                                <h2 className='text-center text-2xl font-bold truncate'><CountUpText value={dataGeneral ? dataGeneral.total_reports : 0} duration={100} className='text-2xl font-bold' /></h2>
                                                <img src={CompanyImage} width={'50px'} alt="Empresas" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='w-full sm:w-1/2 md:w-1/2 lg:w-1/4 p-2'>
                                <Card>
                                    <h1 className='text-center font-bold pb-4'>Total de indicadores</h1>
                                    <div className='flex items-center justify-around'>
                                        <h2 className='text-center text-2xl font-bold truncate'><CountUpText value={dataGeneral ? dataGeneral.total_indicator_groups : 0} duration={100} className='text-2xl font-bold text-blue-600' /></h2>
                                        <img src={CompanyImage} width={'50px'} alt="Empresas" />
                                    </div>
                                </Card>
                            </div> */}
                                </div>
                                <div className="w-full h-full">
                                    <div className="w-full h-full bg-white dark:bg-[#292929] rounded-md p-4">
                                        <Card className="w-full h-full px-0 pt-0 !border-none !ring-0 !shadow-none">
                                            <div className='flex flex-wrap items-start'>
                                                <div className='w-full md:w-1/3'>
                                                    <h1 className='text-center font-bold pb-4 h-15'>Tipos de empresas</h1>
                                                    <div className='px-8 py-2 flex justify-center'>
                                                        <DoughnutChart ref={chartDoughnut1} data={dataGeneral ? dataGeneral.total_company_types : []} />
                                                    </div>
                                                </div>
                                                <div className='w-full md:w-1/3'>
                                                    <h3 className='text-center font-bold pb-4 h-15'>Empresas por Departamento</h3>
                                                    <div className='px-8 py-2 flex justify-center'>
                                                        <DoughnutChart ref={chartDoughnut2} data={dataGeneral ? dataGeneral.total_company_states : []} />
                                                    </div>
                                                </div>
                                                <div className='w-full md:w-1/3'>
                                                    <h3 className='text-center font-bold pb-4 h-15'>Empresas por Municipio</h3>
                                                    <div className='px-8 py-2 flex justify-center'>
                                                        <DoughnutChart ref={chartDoughnut3} data={dataGeneral ? dataGeneral.total_company_cities : []} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </>
                        }

                        {/* <div className='p-2'>
                        <Card>
                            <div className='grid grid-cols-3 gap-4'>
                                {historiesIndicators && historiesIndicators.length > 0 && historiesIndicators.map((history) => (
                                    <div className='m-1' key={history.indicatorId}>
                                        <Card key={history.indicatorId} className="h-full">
                                            <h2 className='text-center font-bold pb-2 h-20 overflow-hidden'>{history.termName}</h2>
                                            <ul className='font-bold p-4'>
                                                <li className='list-disc'><span className='font-light'>Total: </span> {(history.sum).toLocaleString('en-US')}</li>
                                                <li className='list-disc'><span className='font-light'>Promedio: </span> {(history.avg).toLocaleString('en-US')}</li>
                                                <li className='list-disc'><span className='font-light'>Promedio: </span> {(history.avg).toLocaleString('en-US')}</li>
                                                <li className='list-disc'><span className='font-light'>Mediana: </span> {(history.median).toLocaleString('en-US')}</li>
                                                <li className='list-disc'><span className='font-light'>Máximo: </span> {(history.max).toLocaleString('en-US')}</li>
                                                <li className='list-disc'><span className='font-light'>Mínimo: </span> {(history.min).toLocaleString('en-US')}</li>
                                                <li className='list-disc'><span className='font-light'>Datos: </span> {(history.count).toLocaleString('en-US')}</li>
                                            </ul>
                                        </Card>
                                    </div>
                                ))}
                            </div>
                        </Card>
                    </div> */}
                        <div className=''>
                            <div className=''>
                                <div className='p-4 bg-white rounded my-4'>
                                    {dataIndicatorsFormatChart && (
                                        <div className="">
                                            <div className='flex'>
                                                <div className='w-1/2 flex justify-start'><label className="font-semibold">Filtrar variables:</label></div>
                                                <div className='w-1/2 flex justify-end'><small>Presiona ctrl + click para seleccionar múltiples variables</small></div>
                                            </div>
                                            <select
                                                id="select-indicators"
                                                multiple
                                                className="w-full border border-[#097f9f] selection:bg-[#097f9f] selection:text-white p-2 rounded h-40 mt-2"
                                                value={selectedIndicators}
                                                onChange={(e) => {
                                                    const values = Array.from(e.target.selectedOptions).map(o => o.value);
                                                    setSelectedIndicators(values);
                                                }}
                                            >
                                                {dataIndicatorsFormatChart.datasets.map(ds => (
                                                    <option key={ds.label} value={ds.label}>
                                                        {capitalizeFirstLetter(ds.label)}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </div>

                                <div className='mt-4'>
                                    {isLoadingIndicators ? (
                                        <div>
                                            <div className="flex justify-center items-center" style={{ height: '500px' }}>
                                                <div className="text-center">
                                                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                                                    <p className="text-gray-600">Cargando variables...</p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex flex-col gap-4">
                                            <div className='bg-white p-4 rounded mb-4'>
                                                <div onClick={getIndicatorDetails} className='cursor-pointer hover:text-turquesa animate-pulse'>
                                                    <h1 className='mb-4 text-base text-right'>Más información <FontAwesomeIcon icon={faInfoCircle} /></h1>
                                                </div>
                                                <BarChart
                                                    ref={chartBar1}
                                                    data={
                                                        selectedIndicators.length === 0
                                                            ? dataIndicatorsFormatChart
                                                            : {
                                                                labels: dataIndicatorsFormatChart?.labels ?? [],
                                                                datasets: dataIndicatorsFormatChart?.datasets
                                                                    ?.filter(ds => selectedIndicators.includes(ds.label)) ?? []
                                                            }
                                                    }
                                                    title="Indicadores de Ecoeficiencia Consolidado"
                                                    height="300px"
                                                    showTitle={false}
                                                />
                                            </div>

                                            <div className='bg-white p-4 rounded mb-4'>
                                                <h1 className='text-center font-bold pb-4'>Variables por Mes</h1>
                                                <LineChart
                                                    ref={chartLine1}
                                                    data={
                                                        selectedIndicators.length === 0
                                                            ? dataIndicatorsFormatChart
                                                            : {
                                                                labels: dataIndicatorsFormatChart?.labels ?? [],
                                                                datasets: dataIndicatorsFormatChart?.datasets
                                                                    ?.filter(ds => selectedIndicators.includes(ds.label)) ?? []
                                                            }
                                                    }
                                                    title="Variables por Mes"
                                                    height="300px"
                                                    showTitle={false}
                                                />
                                            </div>

                                            <div className='bg-white p-4 rounded mb-4'>
                                                <div className='p-4'>
                                                    <h3 className='text-center p-6 font-bold'>Variables consolidadas:</h3>
                                                    <TableBarChart rows={dataIndicatorsFormatChart ? dataIndicatorsFormatChart.datasets : []} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='py-2'>
                                <div className='bg-white rounded p-4 mb-4'>
                                    <h1 className='text-center font-bold pb-4'>Variables por Mes</h1>
                                    <div>
                                        {isLoadingIndicators ? (
                                            <div className="flex justify-center items-center" style={{ height: '500px' }}>
                                                <div className="text-center">
                                                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                                                    <p className="text-gray-600">Cargando indicadores...</p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                {/* {dataIndicatorsFormatChart && (
                                                <div className="mb-4">
                                                    <label className="font-semibold">Filtrar indicadores (línea):</label>
                                                    <select
                                                        multiple
                                                        className="w-full border p-2 rounded h-40 mt-2"
                                                        value={selectedIndicators}
                                                        onChange={(e) => {
                                                            const values = Array.from(e.target.selectedOptions).map(o => o.value);
                                                            setSelectedIndicators(values);
                                                        }}
                                                    >
                                                        {dataIndicatorsFormatChart.datasets.map(ds => (
                                                            <option key={ds.label} value={ds.label}>
                                                                {ds.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    <p className="text-xs text-gray-600 mt-1">
                                                        Usa CTRL o SHIFT para seleccionar varios.
                                                    </p>
                                                </div>
                                            )} */}


                                                {/* <LineChart
                                                data={
                                                    selectedIndicators.length === 0
                                                        ? dataIndicatorsFormatChart
                                                        : {
                                                            labels: dataIndicatorsFormatChart?.labels ?? [],
                                                            datasets: dataIndicatorsFormatChart?.datasets
                                                                ?.filter(ds => selectedIndicators.includes(ds.label)) ?? []
                                                        }
                                                }
                                                title="Indicadores de Ecoeficiencia por Mes"
                                                height="300px"
                                                showTitle={false}
                                            /> */}
                                                <div className='bg-slate-50 p-4 mt-5'>
                                                    <TableIndicators reportData={dataIndicatorsFormatTable || []} />
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className=''>
                                <div className=''>
                                    <div className='bg-white rounded p-4 mb-4'>
                                        {dataFactors && (
                                            <div className="">
                                                <div className='flex'>
                                                    <div className='w-1/2 flex justify-start'><label className="font-semibold">Filtrar por tipo de emisión evitada:</label></div>
                                                    <div className='w-1/2 flex justify-end'><small>Presiona ctrl + click para seleccionar múltiples tipos</small></div>
                                                </div>
                                                <select
                                                    id="select-factors"
                                                    multiple
                                                    className="w-full border border-[#097f9f] selection:bg-[#097f9f] selection:text-white p-2 rounded h-40 mt-2"
                                                    value={selectedFactors}
                                                    onChange={(e) => {
                                                        const values = Array.from(e.target.selectedOptions).map(o => o.value);
                                                        setSelectedFactors(values);
                                                    }}
                                                >
                                                    {dataFactors.datasets.map(ds => (
                                                        <option key={ds.label} value={ds.label}>
                                                            {capitalizeFirstLetter(ds.label)}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}
                                    </div>

                                    <div className='mt-4'>
                                        {/* <Card className="w-full flex flex-wrap h-full px-0 pt-0 p-4 !border-none !ring-0 !shadow-none"> */}
                                        {!dataFactors || isLoadingFactors
                                            ?
                                            <div>
                                                <div className="flex justify-center items-center" style={{ height: '500px' }}>
                                                    <div className="text-center">
                                                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                                                        <p className="text-gray-600">Cargando indicadores...</p>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className='bg-white p-4 rounded mb-4'>
                                                <div className='w-full'>
                                                    <div className='flex justify-between items-center px-6'>
                                                        <h3 className='text-center p-6 font-bold flex-grow'>Emisiones evitadas</h3>
                                                        <ExportDataButton label="Exportar Excel" onClick={handleExportFactors} disabled={false} />
                                                    </div>
                                                    <BarChartFactors
                                                        ref={chartFactors}
                                                        data={
                                                            selectedFactors.length === 0
                                                                ? (dataFactors ?? { labels: [], datasets: [] })
                                                                : {
                                                                    labels: dataFactors?.labels ?? [],
                                                                    datasets: dataFactors?.datasets
                                                                        ?.filter(ds => selectedFactors.includes(ds.label)) ?? []
                                                                }
                                                        }
                                                        title="Consolidado de ton CO2 no emitidas"
                                                        height="600px"
                                                        showLegend={false}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        {/* </Card> */}
                                    </div>
                                </div>
                            </div>
                            {session && [1].includes(session.type_id) &&
                                <>
                                    <div className=''>
                                        <div className="w-full flex flex-wrap h-full px-0 pt-0 p-4 !border-none !ring-0 !shadow-none bg-white rounded my-4">
                                            <div className='w-full xl:w-1/2 p-4 h-[400px]'>
                                                <h1 className='text-center font-bold pb-4'>Mapa de ubicación de empresas o entidades</h1>
                                                <MapComponent {...filters} />
                                            </div>
                                            <div className='w-full xl:w-1/2 p-4'>
                                                <h1 className='text-center font-bold pb-4 mt-5'>Detalles de ubicación de empresas o entidades</h1>
                                                <BarList data1={dataGeneral ? dataGeneral.total_company_states : []} data2={dataGeneral ? dataGeneral.total_company_cities : []} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className=''>
                                        <div className="bg-white p-4 mb-4 rounded">
                                            <h1 className='text-center font-bold pb-4'>Empresas o entidades del proyecto</h1>
                                            <TableCompanies
                                                data={dataGeneral ? dataGeneral.total_reports_by_company : []}
                                            // selectedCompany={selectedCompany}
                                            // onCompanySelect={handleCompanySelect}
                                            />
                                        </div>
                                    </div>
                                </>
                            }

                        </div>
                    </div>
                </section>
            </section>
            {showModalIndicatorDetails && <ModalIndicatorDetails showModal={showModalIndicatorDetails} setShowModal={setShowModalIndicatorDetails} data={dataIndicatorDetails} />}
        </MainThemeLayout>
    );
}

export default Dashboardv2;